<sd-show-more
  [itemTemplate]="recipeTemplate"
  [showLessButton]="false"
  [size]="sizesEnum.s"
  [showButton]="recipes.length < totalCount"
  [showSize]="showSize"
  [showedRow]="showedRow"
  [isLazyLoading]="isLazyLoading"
  (more)="viewMore.emit($event)"
  [items]="recipes"
  [totalCount]="totalCount"
/>

<ng-template #recipeTemplate let-recipe>
  <article>
    <sd-recipe-card
      [brand]="brand ? brand : recipe?.brand"
      [recipeContent]="recipe"
      [twicPicsAutoSize]="twicPicsAutoSize"
      [isLoading]="isLoading"
      (recipeClicked)="onRecipeClicked(recipe)"
    />
  </article>
</ng-template>
